module.exports = __webpack_public_path__ + "img/menu_button.eff59557.svg";